import { useState, useCallback } from 'react';

/**
 * Custom hook to manage touched state for form fields
 * Consolidates multiple useState calls into a single state object
 * @param {string[]} fieldNames - Array of field names to track
 * @returns {Object} Touched state and handlers
 */
export const useTouchedFields = (fieldNames = []) => {
  const initialState = fieldNames.reduce((acc, fieldName) => {
    acc[fieldName] = false;
    return acc;
  }, {});

  const [touchedFields, setTouchedFields] = useState(initialState);

  const setFieldTouched = useCallback((fieldName, touched = true) => {
    setTouchedFields(prev => ({
      ...prev,
      [fieldName]: touched
    }));
  }, []);

  const isFieldTouched = useCallback((fieldName) => {
    return touchedFields[fieldName] || false;
  }, [touchedFields]);

  const resetTouchedFields = useCallback(() => {
    setTouchedFields(initialState);
  }, [initialState]);

  return {
    touchedFields,
    setFieldTouched,
    isFieldTouched,
    resetTouchedFields
  };
};

export default useTouchedFields;
